import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { tableStyleCompact, thStyleCompact, tdStyleCompact, sectionTitleStyle } from "./printTableStyles";

export default function BhavaAspectsTable({ bhavaData }) {
    const { t } = useTranslation();
    return (
        <div>
            <div style={sectionTitleStyle}>
                {t("BhavaAspectsTitle")}
            </div>
            <table style={tableStyleCompact}>
                <thead>
                    <tr>
                        <th style={thStyleCompact}>{t("Bhavaya")}</th>
                        <th style={thStyleCompact}>{t("Nekatha")}</th>
                        <th style={thStyleCompact}>{t("PlanetAspectsCol3")}</th>
                        <th style={thStyleCompact}>{t("GahasInBhava")}</th>
                        <th style={thStyleCompact}>{t("BhavaAspectsCol4")}</th>
                        <th style={thStyleCompact}>{t("BhavaAspectsCol7")}</th>
                        <th style={thStyleCompact}>{t("BhavaAspectsCol6")}</th>
                    </tr>
                </thead>
                <tbody>
                    {bhavaData.map((row, idx) => (
                        <tr key={idx}>
                            <td style={tdStyleCompact}>{row.bhavaIndex}</td>
                            <td style={tdStyleCompact}>{row.nekatha}</td>
                            <td style={tdStyleCompact}>{row.upaGraha}</td>
                            <td style={tdStyleCompact}>{row.gahasInBhava}</td>
                            <td style={tdStyleCompact}>{row.bnL1}</td>
                            <td style={tdStyleCompact}>{row.bnL4}</td>
                            <td style={tdStyleCompact}>{row.bnL3}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

BhavaAspectsTable.propTypes = {
    bhavaData: PropTypes.array.isRequired,
};
